import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-profile',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-profile.component.html',
  styleUrl: './skeleton-profile.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonProfileComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
